import React from 'react';
import './Stlye.css';
import { NavLink } from 'react-router-dom';
import MetaTags from './MetaTags';

function PrivacyPolicy() {
  return (
    <>
      <MetaTags
        title="Privacy Policy | Smart Resources QLD"
        description="Read our Privacy Policy to understand how Smart Resources QLD collects, uses, and protects your personal information in accordance with the Privacy Act 1988."
        identifyUrl="https://smartresourcesqld.com.au/privacy-policy"
        DCTitle="Privacy Policy | Smart Resources QLD"
        DCDescription="Read our Privacy Policy to understand how Smart Resources QLD collects, uses, and protects your personal information in accordance with the Privacy Act 1988."
        DCSubject="Privacy Policy | Smart Resources QLD"
        Canonical="https://smartresourcesqld.com.au/privacy-policy"
        ogImage="https://smartresourcesqld.com.au/static/media/smart-banner-2.09079fa08d21da7d6cbb.webp"
        ogTitle="Privacy Policy | Smart Resources QLD"
        ogDescription="Read our Privacy Policy to understand how Smart Resources QLD collects, uses, and protects your personal information in accordance with the Privacy Act 1988."
        ogUrl="https://smartresourcesqld.com.au/privacy-policy"
      />
      
      <section className="innr_banner about_innr_banner">
        <div className="page_title_innr">
          <div className="page_title">Privacy Policy</div>
          <ul className="bread_crumb">
            <li><NavLink to="/">Home</NavLink></li>
            <li>Privacy Policy</li>
          </ul>
        </div>
      </section>

      <section className="privacy_policy_section" style={{ padding: '80px 0', backgroundColor: '#ffffff', color: '#333333' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="policy_content" style={{ fontFamily: '"Poppins", sans-serif', lineHeight: '1.8', fontSize: '15px' }}>
                <p style={{ marginBottom: '25px', fontSize: '16px', color: '#555555' }}>
                  Smart Resources QLD ("we", "us", "our") is committed to protecting the privacy of visitors to our 
                  website (smartresourcesqld.com.au) and the clients and prospective clients we deal with in the 
                  course of providing business consulting services in Queensland, Australia. This Privacy Policy explains 
                  how we collect, hold, use and disclose personal information in accordance with the Privacy Act 1988 
                  (Cth) and the Australian Privacy Principles (APPs).
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  1. Information We Collect
                </h3>
                <p style={{ marginBottom: '15px' }}>We may collect the following types of personal information:</p>
                <ul style={{ paddingLeft: '20px', marginBottom: '25px', listStyleType: 'disc' }}>
                  <li style={{ marginBottom: '10px' }}>Contact details you provide through our website contact/enquiry form, such as your name, email address, phone number, business name and the content of your message;</li>
                  <li style={{ marginBottom: '10px' }}>Information you provide when communicating with us by email, phone or in person, including as part of an ongoing consulting engagement;</li>
                  <li style={{ marginBottom: '10px' }}>Technical and usage information collected automatically when you visit our website, such as IP address, browser type, device information, pages viewed, referring website and time spent on the site, collected via Google Analytics and similar cookie-based technologies; and</li>
                  <li style={{ marginBottom: '10px' }}>Any other information you choose to provide to us.</li>
                </ul>
                <p style={{ marginBottom: '25px' }}>
                  We do not knowingly collect sensitive information (as defined under the Privacy Act) unless it is 
                  volunteered by you and reasonably necessary for us to provide our services, and only with your 
                  consent where required.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  2. How We Collect Information
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  We collect personal information directly from you when you complete our website contact form, 
                  send us an email, call us, or otherwise interact with us. We also collect information automatically 
                  through cookies and analytics tools (see Section 6 below) when you browse our website.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  3. Why We Collect, Hold, Use and Disclose Your Information
                </h3>
                <p style={{ marginBottom: '15px' }}>We collect and use personal information for the following purposes:</p>
                <ul style={{ paddingLeft: '20px', marginBottom: '25px', listStyleType: 'disc' }}>
                  <li style={{ marginBottom: '10px' }}>To respond to enquiries submitted through our contact form and to communicate with you about our business consulting services;</li>
                  <li style={{ marginBottom: '10px' }}>To provide, manage and improve the consulting services we deliver to clients;</li>
                  <li style={{ marginBottom: '10px' }}>To understand how visitors use our website and to improve its content, functionality and user experience;</li>
                  <li style={{ marginBottom: '10px' }}>To comply with our legal and regulatory obligations; and</li>
                  <li style={{ marginBottom: '10px' }}>For any other purpose disclosed to you at the time the information is collected, or to which you have consented.</li>
                </ul>
                <p style={{ marginBottom: '25px' }}>
                  We will not use or disclose personal information for any other purpose without your consent, unless 
                  permitted or required by law.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  4. Disclosure of Personal Information
                </h3>
                <p style={{ marginBottom: '15px' }}>We do not sell or rent your personal information. We may disclose personal information to:</p>
                <ul style={{ paddingLeft: '20px', marginBottom: '25px', listStyleType: 'disc' }}>
                  <li style={{ marginBottom: '10px' }}>Our employees, contractors and service providers who assist us in operating our website and delivering our services (for example, website hosting providers, IT support and analytics providers such as Google), on a confidential basis and only to the extent necessary;</li>
                  <li style={{ marginBottom: '10px' }}>Professional advisers, where reasonably necessary; and</li>
                  <li style={{ marginBottom: '10px' }}>Government or regulatory bodies, where required or authorised by law.</li>
                </ul>
                <p style={{ marginBottom: '25px' }}>
                  We do not typically disclose personal information to recipients located outside Australia. If this 
                  changes, we will update this Privacy Policy accordingly and take reasonable steps to ensure any 
                  overseas recipient handles your information consistently with the Australian Privacy Principles.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  5. Data Security
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  We take reasonable steps to protect the personal information we hold from misuse, interference, 
                  loss, and unauthorised access, modification or disclosure. This includes the use of secure systems 
                  and restricting access to personal information to authorised personnel only. However, no method of 
                  electronic transmission or storage is completely secure, and we cannot guarantee absolute security.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  6. Cookies and Website Analytics
                </h3>
                <p style={{ marginBottom: '15px' }}>
                  Our website uses Google Analytics, a web analytics service provided by Google, to collect standard 
                  internet log information and visitor behaviour information in an anonymous/aggregated form. 
                  Google Analytics uses cookies (small text files placed on your device) to help us understand how 
                  visitors use our website, so that we can improve it.
                </p>
                <p style={{ marginBottom: '25px' }}>
                  The information generated by cookies about your use of our website (including your IP address) is 
                  transmitted to and processed by Google in accordance with Google's own privacy policy. You may 
                  disable cookies through your browser settings; however, this may affect the functionality of our 
                  website. For more information on how Google uses data, please visit Google's Privacy & Terms 
                  website.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  7. Access to and Correction of Your Personal Information
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  You may request access to, or correction of, the personal information we hold about you by 
                  contacting us using the details in Section 10 below. We will respond to your request within a 
                  reasonable time. In some circumstances, we may be entitled to refuse access or correction, and if so, 
                  we will provide reasons for our decision.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  8. Retention of Personal Information
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  We retain personal information only for as long as is necessary to fulfil the purposes for which it was 
                  collected, including to satisfy any legal, accounting or reporting requirements, after which it will be 
                  securely destroyed or de-identified.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  9. Complaints
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  If you believe we have breached the Australian Privacy Principles or mishandled your personal 
                  information, please contact us using the details below so that we can investigate and respond. If you 
                  are not satisfied with our response, you may lodge a complaint with the Office of the Australian 
                  Information Commissioner (OAIC) at <a href="https://www.oaic.gov.au" target="_blank" rel="noopener noreferrer" style={{ color: '#800020', fontWeight: '500' }}>www.oaic.gov.au</a>.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  10. Contact Us
                </h3>
                <p style={{ marginBottom: '15px' }}>
                  If you have any questions about this Privacy Policy or wish to access, correct or make a complaint 
                  about your personal information, please contact us at:
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '25px', listStyleType: 'disc' }}>
                  <li style={{ marginBottom: '8px' }}><strong>Business name:</strong> Smart Resources QLD</li>
                  <li style={{ marginBottom: '8px' }}><strong>Website:</strong> <a href="https://smartresourcesqld.com.au" target="_blank" rel="noopener noreferrer" style={{ color: '#800020', fontWeight: '500' }}>smartresourcesqld.com.au</a></li>
                  <li style={{ marginBottom: '8px' }}><strong>Email:</strong> <a href="mailto:reachus@smartresourcesqld.com.au" style={{ color: '#800020', fontWeight: '500' }}>reachus@smartresourcesqld.com.au</a></li>
                </ul>
                <p style={{ marginTop: '20px', fontStyle: 'italic', color: '#777777' }}>
                  This Privacy Policy may be updated from time to time. The latest version will always be available on 
                  our website.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
